import {RotateInteractiveModeEventArgs} from './rotate-interactive-mode-event-args';

export class RotateInteractiveMode extends lt.Controls.ImageViewerInteractiveMode {
  // Constructor
  constructor() {
    super();
    // Create our event
    this._rotate = lt.LeadEvent.create(this, 'rotate');
  }

  // We must provide an implementation for name
  public get name1(): string {
    return 'Rotate (Custom)';
  }

  // The rotate event, we will fire this whenever we rotate the viewer
  private _rotate: lt.LeadEvent;
  public get rotate(): lt.LeadEvent {
    return this._rotate;
  }

  private _dragStartedHandler: lt.Controls.InteractiveDragStartedEventHandler;
  private _dragDeltaHandler: lt.Controls.InteractiveDragDeltaEventHandler;
  private _dragCompletedHandler: lt.Controls.InteractiveDragCompletedEventHandler;

  // Called when the mode is started
  public start(viewer: lt.Controls.ImageViewer): void {
    // Call the base class start method
    super.start(viewer);

    // Subscribe to the dragStarted, dragDelta and dragCompleted
    const service: lt.Controls.InteractiveService = this.interactiveService;
    // service.dragStarted.add(() => this.dragStarted);
    this._dragStartedHandler = service.dragStarted.add((sender, e) => this.dragStarted(sender, e));
    this._dragDeltaHandler = service.dragDelta.add((sender, e) => this.dragDelta(sender, e));
    this._dragCompletedHandler = service.dragCompleted.add((sender, e) => this.dragCompleted(sender, e));
  }

  // Called when the mode is stopped
  public stop(viewer: lt.Controls.ImageViewer): void {
    // Check if we have started
    if (this.isStarted) {
      // Unsubscribe from the events
      const service: lt.Controls.InteractiveService = this.interactiveService;
      service.dragStarted.remove(this._dragStartedHandler);
      service.dragDelta.remove(this._dragDeltaHandler);
      service.dragCompleted.remove(this._dragCompletedHandler);

      // Call the base class stop method
      super.stop(viewer);
    }
  }

  // Called when the user starts a drag operation
  private dragStarted(sender: any, e: lt.Controls.InteractiveDragStartedEventArgs): void {
    // This will check if the mouse button (if any) is correct and if we are on top of the image
    if (this.canStartWork(e)) {
      // Infrom whoever is listening that we have started working
      this.onWorkStarted(lt.LeadEventArgs.empty);
    }
  }

  // Called when the user is dragging
  private dragDelta(sender: any, e: lt.Controls.InteractiveDragDeltaEventArgs): void {
    // If we are not working (for example, the user has clicked the mouse outside the image) then
    // nothing to do
    if (!this.isWorking) {
      return;
    }

    // Perform our operation. Get the change of the drag then increase
    // or decrease the current rotation angle depending on the direction
    const viewer: lt.Controls.ImageViewer = this.imageViewer;
    const change: lt.LeadPointD = e.change;
    const delta: number = 4;
    const oldRotateAngle = viewer.rotateAngle;
    if (change.y < 0) {
      viewer.rotateAngle = viewer.rotateAngle - delta;
    } else if (change.y > 0) {
      viewer.rotateAngle = viewer.rotateAngle + delta;
    }

    if (viewer.rotateAngle !== oldRotateAngle) {
      // The rotate angle has changed, fire our event
      this._rotate.invoke(this, new RotateInteractiveModeEventArgs(viewer.rotateAngle));
    }
  }

  // Called when the user stops dragging
  private dragCompleted(sender: any, e: lt.Controls.InteractiveDragCompletedEventArgs): void {
    // If we are working, signal completion
    if (this.isWorking) {
      this._rotate.invoke(this, new RotateInteractiveModeEventArgs(-999));
      this.onWorkCompleted(lt.LeadEventArgs.empty);
    }
  }
}
